import React from "react";
import { Modal, Button, Table, Row, Col } from "react-bootstrap";
import moment from "moment";

const EMPTY = " --";

const formatDate = (value, dateFormat) => {
    if (!value) return EMPTY;
    if (value instanceof Date) {
        return moment(value).format(dateFormat.toUpperCase());
    }
    return String(value);
};

const formatList = (value) => {
    if (Array.isArray(value)) return value.length ? value.join(", ") : EMPTY;
    return value || EMPTY;
};

const formatRange = (range) =>
    range?.from || range?.to
        ? `${range?.from || "??"} - ${range?.to || "??"}`
        : EMPTY;

const formatType = (value) =>
    value ? String(value).replace(/-/g, " ").toUpperCase() : EMPTY;

const Info = ({ label, value }) => (
    <Col md={6} className="mb-2">
        <div className="text-muted">{label}</div>
        <div className="fw-bold">{value || EMPTY}</div>
    </Col>
);

const BatchConfirmModal = ({
    show,
    onHide,
    onConfirm,
    values,
    isEdit,
    dateFormat,
    courseName,
    tradeCategory,
    trainerList,
    disabled,
}) => {
    const trainingDates = values?.training_dates || [];
    const invigilators = (values?.invigilators || []).filter((i) => i?.name);

    const getTrainerName = (trainerId) =>
        trainerList?.find((t) => t?.id === trainerId)?.full_name || EMPTY;

    return (
        <Modal show={show} onHide={onHide} centered size="lg" scrollable>
            <Modal.Header closeButton>
                <Modal.Title>
                    {isEdit ? "Confirm Changes" : "Confirm New Batch"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-3">
                    Please review the details below before saving.
                </p>

                <Row>
                    <Info label="Type" value={values?.type?.toUpperCase()} />
                    <Info label="Name" value={values?.name} />
                    <Info
                        label="Test Date"
                        value={formatDate(values?.test_date, dateFormat)}
                    />
                    <Info
                        label="Test Venue"
                        value={formatList(values?.test_venue)}
                    />
                    <Info
                        label="Training Venue"
                        value={formatList(values?.training_venue)}
                    />
                    <Info label="Course" value={courseName} />
                    {values?.type?.toLowerCase() === "attc" && (
                        <Info label="Trade Category" value={tradeCategory} />
                    )}
                </Row>

                <h6 className="mt-3">Training Dates ({trainingDates.length})</h6>
                {trainingDates.length ? (
                    <Table bordered size="sm" responsive>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>AM</th>
                                <th>PM</th>
                                <th>EV</th>
                                <th>Trainer</th>
                                <th>Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            {trainingDates.map((item, index) => (
                                <tr key={`confirm-training-${index}`}>
                                    <td>{formatDate(item?.date, dateFormat)}</td>
                                    <td>{formatRange(item?.am)}</td>
                                    <td>{formatRange(item?.pm)}</td>
                                    <td>{formatRange(item?.ev)}</td>
                                    <td>{getTrainerName(item?.trainer_id)}</td>
                                    <td>{formatType(item?.training_type)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <p className="text-muted">No training dates added.</p>
                )}

                <h6 className="mt-3">Invigilators ({invigilators.length})</h6>
                {invigilators.length ? (
                    <ol className="mb-0">
                        {invigilators.map((item, index) => (
                            <li key={`confirm-invigilator-${index}`}>
                                {item.name}
                            </li>
                        ))}
                    </ol>
                ) : (
                    <p className="text-muted mb-0">No invigilators added.</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={onHide}
                    disabled={disabled}
                >
                    Back to edit
                </Button>
                <Button
                    variant="primary"
                    onClick={onConfirm}
                    disabled={disabled}
                >
                    Yes, Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BatchConfirmModal;